import React from "react";
import { motion } from "framer-motion";
import { waLink } from "@/data/site";
import { FlaskConical, MessageSquare } from "lucide-react";

export default function CTASection({ onBook }) {
  return (
    <section className="py-16 md:py-24" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="relative bg-navy rounded-[2.5rem] px-7 py-14 md:py-20 text-center overflow-hidden shadow-[0_40px_100px_-30px_rgba(10,37,64,0.6)]">
          <div className="absolute -top-24 -left-24 w-96 h-96 bg-turq/20 rounded-full blur-3xl" />
          <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-turq/10 rounded-full blur-3xl" />
          <div className="relative max-w-2xl mx-auto">
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight">Your Health Deserves the Best Care</h2>
            <p className="text-white/70 mt-5 text-lg">Book your laboratory tests with confidence. Fast, accurate and reliable diagnostics for you and your family.</p>
            <div className="mt-8 flex flex-wrap gap-3 justify-center">
              <button onClick={() => onBook()} className="inline-flex items-center gap-2 bg-turq hover:bg-turq-dark text-white rounded-full px-8 py-4 font-medium transition-all hover:-translate-y-0.5 shadow-[0_10px_30px_rgba(0,180,216,0.4)]" data-testid="cta-book-btn">
                <FlaskConical className="w-5 h-5" /> Book a Test
              </button>
              <a href="#contact" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-xl text-white border border-white/20 rounded-full px-8 py-4 font-medium transition-all" data-testid="cta-contact-btn">
                <MessageSquare className="w-5 h-5" /> Contact Us
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
